import Page from './Page';
import SignIn from '../components/SignIn';
import { initShowHidePassword } from '~/components/ShowHidePassword';

import $ from "jquery";
import _ from "lodash";
import {getParameterValue, gotoLogin, isNullish, navigateTo, returnUrl} from "~/utils";
import {getApi, logout, userInfo, UserInfo, getImpersonator} from "~/auth";
import UI from "~/ui";
import {t} from "~/hooks/useI18n";

let _signIn: SignIn | null = null;

class Login extends Page {
    protected signInModalEnabled: boolean = false; // disabilito il modal di login in questa pagina
    protected checkUserOnInit: boolean = false; // non controllo l'utente all'inizio e non carico il menu
    constructor() {
        super('login', 'Login');
    }
    
    private get returnUrl(): string | null {
        return (document.getElementById("returnUrl") as HTMLInputElement)?.value as string;
    }
    public async pageStart(): Promise<void> {
        initShowHidePassword();
        _signIn = new SignIn(this);
        let retUrl = this.returnUrl || returnUrl();
        _signIn.onLogin(async (user: UserInfo) => {
            getApi().clearCached("userMenu");
            const impersonator = await getImpersonator();
            
            if (!user.isEmailConfirmed) {
                await getApi().fetchWithAuth("POST /resendConfirmationEmail", {
                    body: JSON.stringify({
                        email: user.email,
                        clientId: window.WsAuthClientCode,
                        callbackUrl: window.BaseUrlWeb + "Home/ConfirmEmail"
                    })
                });

                //TODO: I18n
                let _ = UI.confirmOneButton("", "Il tuo indirizzo E-mail non è ancora stato verificato.<br/>" +
                    "Per accedere, clicca sul link nell’E-mail di conferma che ti è stata inviata.");

            } else if (user.isPasswordScaduta && impersonator == null) {
                let url = window.BaseUrlWeb + "cambio-password";
                if (retUrl) url += "?returnUrl=" + encodeURIComponent(retUrl);
                await navigateTo(url);
            } else if (user.consensiIncompleti) {
                try{
                    await this.acquisisciConsensi();
                } catch (error) {
                    console.error("Errore in acquisizione consensi:", error);
                    await gotoLogin(retUrl, t("messages.errorAcquisizioneConsensi"));
                }
                
            } else {
                let landing = retUrl || window.BaseUrlWeb + "dashboard";
                
                returnUrl("");
                
                await navigateTo(landing as string);
            }

        });
        
        if (!returnUrl() && this.returnUrl) {
            returnUrl(this.returnUrl);
        }
        await _signIn.activate();
        
        //eventuali errori di login di ritorno in querystring dai providers esterni
        let error = getParameterValue("error");

        if (!isNullish(error)) {
            _signIn.showMessage(error!, "alert-danger");
        }

        let message = sessionStorage.getItem("loginMessage") as string;
        if (!isNullish(message)) {
            _signIn.showMessage(message,"alert-success");
            sessionStorage.removeItem("loginMessage");
        }
        
        // await this.clearLoggedUser();
        
        return Promise.resolve();
    }
    
    private async clearLoggedUser() {
        var user = await userInfo();
        if (user.isAuthenticated) {
            try {
                await logout(false);
                await this.loadUserMenu();
            }
            catch (err) {
                console.error("Errore durante il logout:", err);
            }
        }
    }
    
    public pageInit(): Promise<void> { 
        return Promise.resolve(); 
    }


    
}


export default Login